import { render } from "./OmnichannelOverviewResume.vue?vue&type=template&id=5ab41822&scoped=true"
import script from "./OmnichannelOverviewResume.vue?vue&type=script&lang=js"
export * from "./OmnichannelOverviewResume.vue?vue&type=script&lang=js"

import "./OmnichannelOverviewResume.vue?vue&type=style&index=0&id=5ab41822&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab41822"]])

export default __exports__